// Links a la TIENDA y copiado al portapapeles, compartidos por las pantallas que los ofrecen.
//
// La base sale de REACT_APP_STOREFRONT_URL (localhost en local, demo. en staging, el dominio en
// prod): REACT_APP_REDIRECT_LOGIN apunta al backoffice fuera de local, y un link armado con ella
// llevaba al admin (ver TournamentPage).

var config = process.env;

export const storefrontUrl = (path) => {
    const base = (config.REACT_APP_STOREFRONT_URL || '').replace(/\/+$/, '');
    return `${base}${path.startsWith('/') ? path : `/${path}`}`;
};

// Link público de un evento o de una jornada suelta.
export const eventPublicUrl = (slug) => storefrontUrl(`/eventos/${encodeURIComponent(slug)}`);

// Link único de una serie del club: la página con sus próximas jornadas.
export const seriesPublicUrl = (slug) => storefrontUrl(`/club/${encodeURIComponent(slug)}`);

// Link público de una mesa abierta: el detalle donde la gente se anota. Sólo sirve mientras la
// mesa está publicada y su jornada no pasó (la tienda contesta "ya no está disponible").
export const openTablePublicUrl = (id) => storefrontUrl(`/mesas-abiertas/${encodeURIComponent(id)}`);

// Copia `text` y devuelve true si lo logró. execCommand y no navigator.clipboard: el backoffice
// se sirve por http en la red del local, y la Clipboard API sólo existe en contextos seguros.
export function copyText(text) {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.top = '-1000px';
    document.body.appendChild(ta);
    ta.select();
    let ok = false;
    try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
    document.body.removeChild(ta);
    return ok;
}

// Copia un link avisando; si el navegador no deja copiar, lo muestra para copiarlo a mano.
export function copyLink(url) {
    if (copyText(url)) window.alert(`Link copiado:\n${url}`);
    else window.prompt('Copiá el link:', url);
}
